module.exports = __webpack_public_path__ + "static/rows-bd0308276e5f900493092750d1c9e281.png";